


import React, { createContext, useState, useContext } from "react";

const EnergiaCombustivelContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaCombustivel_id, setEnergiaCombustivel_id] = useState();

  return (
    <EnergiaCombustivelContext.Provider value={{ energiaCombustivel_id, setEnergiaCombustivel_id }} >
      {children}
    </EnergiaCombustivelContext.Provider>
  );
}

export function useEnergiaCombustivelContext() {
  const context = useContext(EnergiaCombustivelContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaCombustivel_id, setEnergiaCombustivel_id } = context;
  return { energiaCombustivel_id, setEnergiaCombustivel_id };
}

